import { Box } from '@mui/material';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import SettingsIcon from '@mui/icons-material/Settings';

import AssistantImage from '@public/images/assistant/myta/assistant.jpg';
import {
  assistantSize,
  showMuteButtonOnHover,
} from '@core/assistant/constants';
import { useAssistant } from '@core/assistant/providers/Provider';
import { SCREENS } from '@core/assistant/interfaces';

import { useStyles } from './styles';

const Assistant = () => {
  const classes = useStyles();

  const { stopPlayback, isMuted, setIsMuted, useProfileLanguage, navigate, setOpen } = useAssistant();

  const handleMicClick = () => {
    try {
      stopPlayback();
    } catch (error) {
      //
    }
    setIsMuted();
  };

  return (
    <Box sx={classes.box}>
      <div
        className={'assistant' + (showMuteButtonOnHover ? ' with-hover' : '')}
      >
        <img
          className="assistant-avatar"
          id="ai-assistant"
          src={AssistantImage}
          style={{
            width: `${assistantSize.width}px`,
            height: `${assistantSize.height}px`,
          }}
        />
        <div className="assistant-controls">
          <div
            className={'assistant-mute' + (isMuted ? ' muted' : '')}
            onClick={() => handleMicClick()}
          >
            {isMuted ? <VolumeOffIcon /> : <VolumeUpIcon />}
          </div>
          {!useProfileLanguage && (
            <div
              className="assistant-settings"
              onClick={() => {
                setOpen(true);
                navigate(SCREENS.SETTINGS);
              }}
            >
              <SettingsIcon />
            </div>
          )}
        </div>
        <canvas id="ai-assistant-canvas" className="ai-assistant-canvas" />
      </div>
    </Box>
  );
};

export default Assistant;
